export enum FighterType {
  STUDENT = 'Student',
  HEAD_COACH = 'Head Coach',
  MASTER = 'Master',
  OTHER = 'Other',
  PROFESSOR = 'Professor',
}

export type Fighter = {
  phoneNumber: string
  name: string
  type: string
  belt: string
  degree: number
}
